import React from "react";
import { taskTodoData } from "../../../mock-data/home-mock-data";
import tasksLogo from "../../../assets/home/sidebar/Tasks.png";
import { Box } from "@mui/material";

const tasks = () => {
  return (
    <>
      <Box className="tasks-todo br-16" marginTop="20px">
        <Box
          className="tasks-todo-icon"
          display="flex"
          gap="20px"
          paddingBottom="10px"
        >
          <div className="tasks-todo-btn">
            <img src={tasksLogo} />
          </div>
          <h2>Tasks</h2>
        </Box>
        {taskTodoData.map((item) => {
          return (
            <>
              <Box
                className="tasks-todo-wrap"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                paddingRight="10px"
                marginBottom="10px"
                sx={{borderLeft: `4px solid ${item.color}`}}
              >
                <Box
                  className="tasks-todo-content"
                  padding="12px 15px"
                  display="flex"
                  gap="10px"
                  alignItems="center"
                >
                  <img src={item.icon} alt="" />
                  <h2>{item.title}</h2>
                </Box>
                <h3>{item.count}</h3>
              </Box>
            </>
          );
        })}
      </Box>
    </>
  );
};

export default tasks;
